import defaultImg from "assets/icons/default_product_picture.svg";
import { IProductPick } from "contexts/RequestQuoteContext";
import { BoxIcon, PriceIcon } from "icons";
import React from "react";
import { truncateMessage } from "utils";
import {
  CardImageProduct,
  FillImageProduct,
  NameProduct,
} from "./CatalogStyles";
import ProductCounter from "./ProductCounter";
import { Grid } from "@material-ui/core";
import { useStyles } from "./ListCatalogue";

interface IItemCatalog {
  product: IProductPick;
  isChecked?: boolean;
  counter?: number;
  onChangeCountValue: (item: IProductPick, counter: number) => void;
  isForDelivery?: boolean;
  maxCountValue?: number;
}
export default function ItemCatalog({
  product,
  isChecked = false,
  counter,
  onChangeCountValue,
  isForDelivery = false,
  maxCountValue,
}: IItemCatalog) {
  const styles = useStyles();
  
  return (
    <Grid container xs={12} className={styles.productWrapper}>
      <Grid item container xs={5}>
        <CardImageProduct>
          <FillImageProduct src={product?.photoUrl || defaultImg} alt="image produit" />
        </CardImageProduct>
        <NameProduct>{truncateMessage(product?.name || product?.description, 20)}</NameProduct>
      </Grid>
      <Grid item xs={2}>
        {product?.reference || "N/A"}
      </Grid>
      <Grid item xs={1}>
        {product?.weight}
      </Grid>
      <Grid item container xs={2}>
        {product?.value ? `${product?.value}` : "N/A"}
      </Grid>
      <Grid item xs={2}>
        {isChecked && (
          <ProductCounter
            countValue={counter}
            onChangeCountValue={onChangeCountValue}
            product={product}
            isForDelivery={isForDelivery}
            maxCountValue={maxCountValue}
          />
        )}
      </Grid>
    </Grid>
  );
}
